// extracted by mini-css-extract-plugin
module.exports = {"actions":"CallActions_actions__aZklC","decline":"CallActions_decline__ho5CW","accept":"CallActions_accept__M5lgT","icons":"CallActions_icons__1DJfU"};